"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ComplianceIssueDetailType = exports.ComplianceIssueCode = exports.ComplianceIssueEntityType = exports.OCSReportEntryStatus = exports.OCSReportEntryType = void 0;
var OCSReportEntryType;
(function (OCSReportEntryType) {
    OCSReportEntryType["RETAILER"] = "retailer";
    OCSReportEntryType["SUBMISSION_EVENT"] = "submission_event";
    OCSReportEntryType["SUBMISSION_POSITION"] = "submission_position";
    OCSReportEntryType["SUBMISSION_EVENT_ATTEMPT"] = "submission_event_attempt";
    OCSReportEntryType["SUBMISSION_POSITION_ATTEMPT"] = "submission_position_attempt";
    OCSReportEntryType["PROCESS_ON_DATE"] = "process_on_date";
    OCSReportEntryType["RESYNC_PRODUCT"] = "resync_product";
})(OCSReportEntryType || (exports.OCSReportEntryType = OCSReportEntryType = {}));
var OCSReportEntryStatus;
(function (OCSReportEntryStatus) {
    OCSReportEntryStatus["PREPARING"] = "preparing";
    OCSReportEntryStatus["SUBMITTING"] = "submitting";
    OCSReportEntryStatus["SUCCESSFUL"] = "successful";
    OCSReportEntryStatus["FAILED"] = "failed";
})(OCSReportEntryStatus || (exports.OCSReportEntryStatus = OCSReportEntryStatus = {}));
var ComplianceIssueEntityType;
(function (ComplianceIssueEntityType) {
    ComplianceIssueEntityType["PRODUCT"] = "PRODUCT";
    ComplianceIssueEntityType["SALE"] = "SALE";
})(ComplianceIssueEntityType || (exports.ComplianceIssueEntityType = ComplianceIssueEntityType = {}));
var ComplianceIssueCode;
(function (ComplianceIssueCode) {
    ComplianceIssueCode["MISSING_BARCODE"] = "MISSING_BARCODE";
    ComplianceIssueCode["MISSING_SKU"] = "MISSING_SKU";
})(ComplianceIssueCode || (exports.ComplianceIssueCode = ComplianceIssueCode = {}));
var ComplianceIssueDetailType;
(function (ComplianceIssueDetailType) {
    ComplianceIssueDetailType["UNKNOWN"] = "unknown_issue";
    ComplianceIssueDetailType["CREDENTIAL"] = "credential";
    ComplianceIssueDetailType["MERCHANT"] = "merchant";
    ComplianceIssueDetailType["SALE"] = "sale";
    ComplianceIssueDetailType["PRODUCT"] = "product";
    ComplianceIssueDetailType["CAREGIVER"] = "caregiver";
    ComplianceIssueDetailType["CUSTOMER"] = "customer";
    ComplianceIssueDetailType["PHYSICIAN"] = "physician";
})(ComplianceIssueDetailType || (exports.ComplianceIssueDetailType = ComplianceIssueDetailType = {}));
(function (ComplianceIssueCode) {
    ComplianceIssueCode["UNKNOWN_ISSUE_DETECTED"] = "UNKNOWN_ISSUE_DETECTED";
    // merchant issue code
    ComplianceIssueCode["MISSING_OR_INVALID_RETAILER_LICENSE"] = "MISSING_OR_INVALID_RETAILER_LICENSE";
    ComplianceIssueCode["MISSING_RETAILER_NAME"] = "MISSING_RETAILER_NAME";
    ComplianceIssueCode["MISSING_RETAILER_PHONE"] = "MISSING_RETAILER_PHONE";
    ComplianceIssueCode["MISSING_RETAILER_ADDRESS"] = "MISSING_RETAILER_ADDRESS";
    ComplianceIssueCode["MISSING_OR_INVALID_RETAILER_STATE_OR_PROVINCE"] = "MISSING_OR_INVALID_RETAILER_STATE_OR_PROVINCE";
    ComplianceIssueCode["MISSING_OR_INVALID_RETAILER_CITY"] = "MISSING_OR_INVALID_RETAILER_CITY";
    ComplianceIssueCode["MISSING_OR_INVALID_RETAILER_POSTAL_CODE"] = "MISSING_OR_INVALID_RETAILER_POSTAL_CODE";
    // product issue code
    ComplianceIssueCode["MISSING_OR_INVALID_PRODUCT_UNIT"] = "MISSING_OR_INVALID_PRODUCT_UNIT";
    ComplianceIssueCode["MISSING_OR_INVALID_PRODUCT_BATCH_QUANTITY"] = "MISSING_OR_INVALID_PRODUCT_BATCH_QUANTITY";
    ComplianceIssueCode["MISSING_OR_INVALID_PRODUCT_BATCH_COMPLIANCE_ID"] = "MISSING_OR_INVALID_PRODUCT_BATCH_COMPLIANCE_ID";
    ComplianceIssueCode["MISSING_OR_INVALID_RECOMMENDATION_ISSUE_DATE"] = "MISSING_OR_INVALID_RECOMMENDATION_ISSUE_DATE";
    ComplianceIssueCode["MISSING_OR_INVALID_RECOMMENDATION_AUTHORIZED_REFILLS"] = "MISSING_OR_INVALID_RECOMMENDATION_AUTHORIZED_REFILLS";
    ComplianceIssueCode["MISSING_OR_INVALID_FILL_NUMBER"] = "MISSING_OR_INVALID_FILL_NUMBER";
    ComplianceIssueCode["MISSING_OR_INVALID_WHOLE_DAY_DISPENSED_UNIT"] = "MISSING_OR_INVALID_WHOLE_DAY_DISPENSED_UNIT";
    ComplianceIssueCode["MISSING_OR_INVALID_PARTIAL_FILL_INDICATOR"] = "MISSING_OR_INVALID_PARTIAL_FILL_INDICATOR";
    // caregiver issue code
    ComplianceIssueCode["MISSING_OR_INVALID_PICKED_UP_BY"] = "MISSING_OR_INVALID_PICKED_UP_BY";
    ComplianceIssueCode["MISSING_OR_INVALID_CAREGIVER_LICENSE"] = "MISSING_OR_INVALID_CAREGIVER_LICENSE";
    ComplianceIssueCode["MISSING_CAREGIVER_FIRST_NAME"] = "MISSING_CAREGIVER_FIRST_NAME";
    ComplianceIssueCode["MISSING_CAREGIVER_LAST_NAME"] = "MISSING_CAREGIVER_LAST_NAME";
    // customer issue code
    ComplianceIssueCode["MISSING_OR_INVALID_CUSTOMER_ID"] = "MISSING_OR_INVALID_CUSTOMER_ID";
    ComplianceIssueCode["MISSING_CUSTOMER_FIRST_NAME"] = "MISSING_CUSTOMER_FIRST_NAME";
    ComplianceIssueCode["MISSING_CUSTOMER_LAST_NAME"] = "MISSING_CUSTOMER_LAST_NAME";
    ComplianceIssueCode["MISSING_CUSTOMER_BIRTHDAY"] = "MISSING_CUSTOMER_BIRTHDAY";
    ComplianceIssueCode["MISSING_CUSTOMER_GENDER"] = "MISSING_CUSTOMER_GENDER";
    ComplianceIssueCode["MISSING_CUSTOMER_PHONE"] = "MISSING_CUSTOMER_PHONE";
    ComplianceIssueCode["MISSING_CUSTOMER_ADDRESS"] = "MISSING_CUSTOMER_ADDRESS";
    ComplianceIssueCode["MISSING_OR_INVALID_CUSTOMER_STATE_OR_PROVINCE"] = "MISSING_OR_INVALID_CUSTOMER_STATE_OR_PROVINCE";
    ComplianceIssueCode["MISSING_OR_INVALID_CUSTOMER_CITY"] = "MISSING_OR_INVALID_CUSTOMER_CITY";
    ComplianceIssueCode["MISSING_OR_INVALID_CUSTOMER_POSTAL_CODE"] = "MISSING_OR_INVALID_CUSTOMER_POSTAL_CODE";
    // physician issue code
    ComplianceIssueCode["MISSING_OR_INVALID_PHYSICIAN_ID"] = "MISSING_OR_INVALID_PHYSICIAN_ID";
    ComplianceIssueCode["MISSING_PHYSICIAN_FIRST_NAME"] = "MISSING_PHYSICIAN_FIRST_NAME";
    ComplianceIssueCode["MISSING_PHYSIAN_LAST_NAME"] = "MISSING_PHYSIAN_LAST_NAME";
})(ComplianceIssueCode || (exports.ComplianceIssueCode = ComplianceIssueCode = {}));
//# sourceMappingURL=enums.js.map